import { HTTP_REQUEST_TYPE, NEWS_API } from "../constants/api";
import { INewsModalData } from "../pages/dataConfig/News/news";
import { handleRequestData, sendHttpRequest } from "./api";

// get or search news list
const getNewsList = async (keyword: string = '') => {
  const [, resp] = await sendHttpRequest(
    HTTP_REQUEST_TYPE.get,
    NEWS_API.GET_NEWS_LIST,
    !!keyword ?
      {
        keyword
      } : {}
  );

  const [isSucceed, detail, respData] = handleRequestData(resp);
  return [isSucceed, detail, respData?.newsList || []];
};

// create news
const createNews = async (news: INewsModalData) => {
  const [, resp] = await sendHttpRequest(
    HTTP_REQUEST_TYPE.post,
    NEWS_API.CREATE_NEWS,
    {
      ...news
    }
  );
  const [isSucceed, errorMsg, respData, status] = handleRequestData(resp);
  return [isSucceed, errorMsg, respData, status];
};

// update news
const updateNews = async (news: INewsModalData) => {
  const [, resp] = await sendHttpRequest(
    HTTP_REQUEST_TYPE.post,
    NEWS_API.UPDATE_NEWS,
    {
      ...news
    }
  );
  const [isSucceed, errorMsg, respData, status] = handleRequestData(resp);
  return [isSucceed, errorMsg, respData, status];
};

// delete news
const deleteNews = async (id: string) => {
  const [, resp] = await sendHttpRequest(
    HTTP_REQUEST_TYPE.delete,
    NEWS_API.DELETE_NEWS,
    {
      _id: id
    }
  );
  const [isSucceed, errorMsg, respData, status] = handleRequestData(resp);
  return [isSucceed, errorMsg, respData, status];
};

export {
  getNewsList,
  createNews,
  updateNews,
  deleteNews,
};
